import { updateOrderQtyorProducts } from "@DSG/Common/Utilities/CoveoUtilities";
import { HasProductContext, withProductContext } from "@DSG/Components/Coveo/CoveoContext/CoveoProductContext";
import DSGProductInventoryMessageCustom from "@DSG/Components/DSGProductInventoryMessageCustom";
import Button from "@DSG/MobiusOverrides/Button/Button";
import Minus from "@DSG/MobiusOverrides/Icons/Minus";
import Plus from "@DSG/MobiusOverrides/Icons/Plus";
import colorPallete, { bodyFonts, labelFonts, printFonts } from "@DSG/MobiusOverrides/styles/variables";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@DSG/MobiusOverrides/TextField";
import CoveoApplicationState from "@DSG/Store/Data/CoveoApplicationState/CoveoApplicationState";
import { DISPATCH_PRODUCTINFO } from "@DSG/Store/Reducer/CoveoCommerceReducer";
import { UpdatedProductQtyInfo } from "@DSG/Type/CoveoModels";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ChangeEvent, useEffect, useState } from "react";
import { connect, ResolveThunks, useDispatch } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends TextFieldProps {
    configurationCompleted?: boolean;
    configurationSelection?: SafeDictionary<string>;
    variantSelectionCompleted?: boolean;
    labelOverride?: React.ReactNode;
    extendedStyles?: TextFieldPresentationProps;
    hideInventoryMsgOnQtyChange?: boolean;
}

const mapStateToProps = (state: CoveoApplicationState) => {
    return {
        isProductDetailsPage: getCurrentPage(state).type === "ProductDetailsPage",
        isPLP: getCurrentPage(state).type === "ProductListPage",
    }
}
type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps>;

const mapDispatchToProps = {
    // addToCart,
    // updateCartLine,
    // removeCartLine,
};


export interface CoveoProductQuantityOrderedCustomStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
}

export const coveoProductQuantityOrderedCustomStyles: CoveoProductQuantityOrderedCustomStyles = {
    innerWrapper: {
        css: css`
            display: flex;
            min-width: 97px;
            max-width: 97px;
            border: 1px solid ${colorPallete.grey300};
            padding: 0 8px;
            border-radius: 24px;
            height: 32px;
            button {
                &, &:hover, &:disabled, &:active, &:focus {
                    background: none;
                    border: none;
                    min-height: initial;
                    height: 30px;
                    padding: 0;
                    color: ${colorPallete.grey800};
                    width: 16px;
                    align-items: center;
                    display: flex;
                }
            }

            [data-test-selector="product_qtyOrdered"] {
                font: ${bodyFonts.body2SemiBoldSm.fontWeight} ${bodyFonts.body2SemiBoldSm.fontSize} ${bodyFonts.body2SemiBoldSm.fontFamily} !important;
                line-height: 32px;
            }
            .printOnly {
                display: none;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        height: 36px;
                        min-width: 111px;
                        max-width: 111px;
                        padding: 0 16px;
                        button {
                            &, &:hover, &:disabled, &:active, &:focus {
                                min-height: 34px;
                            }
                        }
                        [data-test-selector="product_qtyOrdered"] {
                            line-height: 36px;
                        }
                    `,
                ],
                "min",
            )}
            [class*="FormInputWrapper"] {
                input:not(.react-datetime-picker__inputGroup__input) {
                    height: 30px;
                    min-height: 30px;
                    border-width: 0;
                    &, &:hover, &:focus, &:active, &:disabled {
                        min-width: 41px;
                        padding: 3px 8px;
                        text-align: center;
                        border-radius: 0;
                        background:  none;
                        font: ${bodyFonts.body2SemiBoldSm.fontWeight} ${bodyFonts.body2SemiBoldSm.fontSize} ${bodyFonts.body2SemiBoldSm.fontFamily};
                        line-height: 24px;
                    }
                    &, &:focus, &:hover, &:focus-visible, &:active, &:disabled {
                        border-width: 0;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 28px;
                                min-height: 28px;
                                &, &:hover, &:focus, &:active, &:disabled {
                                    font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                                    line-height: 28px;
                                    min-width: 47px;
                                }
                            `,
                        ],
                        "min",
                        )}
                }
            }
            [class*="FormFieldStyle"] {
                justify-content: center;
            }
            @media print {
                height: auto;
                padding: 0;
                min-width: initial;
                max-width: initial;
                [class*="FormFieldStyle"] {
                    display: none
                }
                .printOnly {
                    display: inline-block;
                    font-size: ${printFonts.bodyRegularSm.fontSize};
                    line-height: ${printFonts.bodyRegularSm.lineHeight};
                }
            }
        `
    },
    wrapper: {
        css: css`
            margin-top: 8px;
            margin-bottom: 16px;
            display: flex;
            width: 100%;
            label {
                font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/32px ${labelFonts.label2Regular.fontFamily};
                padding-right: 8px;
                color: ${colorPallete.grey600};
                white-space: nowrap;
            }
            &.focused {
                > div {
                    border: 2px solid ${colorPallete.grey800} !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
            theme,
            [
                null,
                null,
                css`
                    margin-bottom: 24px;
                    label {
                        line-height: 36px;
                        font-size: ${labelFonts.label1Regular.fontSize};
                    }
                `,
            ],
            "min",
            )}
            @media print {
                label {
                    line-height: initial;
                    font-size: ${printFonts.bodyRegularSm.fontSize};
                }
                > div {
                    padding: 0;
                    border: none;
                }
            }
        `
    }
}
export const productQuantityOrderedStyles: TextFieldPresentationProps = {
    cssOverrides: {
        formInputWrapper: css`
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                /* ISC-11023 deal with this. */
                /* stylelint-disable-next-line */
                -webkit-appearance: none;
                margin: 0;
            }
        `,
        inputSelect: css`
            /* ISC-11023 deal with this. */
            /* stylelint-disable-next-line */
            -moz-appearance: textfield;
        `,
    },
};
const stylesCustom = coveoProductQuantityOrderedCustomStyles;

const CoveoProductQuantityOrdered = ({
    coveoproductContext: {
        coveoProduct,
        coveoProductInfo,
        onQtyOrderedChanged,
    },
    labelOverride,
    hideInventoryMsgOnQtyChange,
    isProductDetailsPage,
    isPLP,
    extendedStyles,
}:Props) =>{

    const dispatch = useDispatch();
    const { productId, productNumber, minimumOrderQty, unitofmeasure,inventory } = coveoProduct;
    const [styles] = useState(() => mergeToNew(coveoProductQuantityOrderedCustomStyles, extendedStyles));
    const [productQty, setProductQty] = useState("");
    const [isQtychanged,setIsQtyChanged] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    const unitOfMeasure = coveoProduct.pricing?.additionalResults?.realTimeUnitOfMeasure || coveoProduct.pricing?.unitOfMeasure || coveoProduct.unitofmeasure;
    const availability =
    inventory?.inventoryAvailabilityDtos?.find(
        o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
    )?.availability || undefined;
   
    const handleCoveoChangeQty  = (productid:string, qty:number) => {
        dispatch({
            type: "Coveo/DispatchProductInfo",
            query:{
                productId: productid,
                qtyOrdered: qty
            }   
        });
    }
    useEffect(() => {
        if (coveoProductInfo.qtyOrdered === Number(productQty)) {
            return;
        }
        setProductQty(`${coveoProductInfo.qtyOrdered || ""}`);
        
    }, [coveoProduct]);
    
    const keyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === 13) {
            (event.target as any).blur();
        }
    };
    
    const qtyChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setProductQty(value);

        if (!onQtyOrderedChanged) {
            logger.warn(`There was no onQtyOrderedChanged passed to the ProductContext for ${productId}`);
            return;
        }

        const possibleNumber = Number(value);
        if (!Number.isNaN(possibleNumber)) {
            setIsQtyChanged(true);
            onQtyOrderedChanged(possibleNumber);
            handleCoveoChangeQty(coveoProductInfo.productId,coveoProductInfo.qtyOrdered)
        }
    };
            
    const handleDecrease = (qty:string) => {
        let value = parseInt(qty,10)-1;
        if(value < 1)
        {
        value = 1;
        }
        setProductQty(value.toString());

        if (!onQtyOrderedChanged) {
            logger.warn(`There was no onQtyOrderedChanged passed to the ProductContext for ${productId}`);
            return;
        }

        const possibleNumber = Number(value);
        if (!Number.isNaN(possibleNumber)) {
            setIsQtyChanged(true);
            onQtyOrderedChanged(possibleNumber);
            handleCoveoChangeQty(coveoProductInfo.productId,coveoProductInfo.qtyOrdered)
        }
    };
                  
    const handleIncrease = (qty:string) => {
        let value = parseInt(productQty, 10) + 1;
        if(value < 1)
        {
            value = 1;
        } 
        setProductQty(value.toString());
        if (!onQtyOrderedChanged) {
            logger.warn(`There was no onQtyOrderedChanged passed to the ProductContext for ${productId}`);
            return;
        }

        const possibleNumber = Number(value);
        if (!Number.isNaN(possibleNumber)) {
            setIsQtyChanged(true); 
            onQtyOrderedChanged(possibleNumber);
            handleCoveoChangeQty(coveoProductInfo.productId,coveoProductInfo.qtyOrdered)
           
        }

    };

    return (
        <>
            <StyledWrapper className={`number-input ${isFocused ? "focused" : ""}`} {...stylesCustom.wrapper}>
                <label htmlFor="product_qty">
                    {labelOverride ?? translate("Qty:")}
                </label>
                <StyledWrapper {...stylesCustom.innerWrapper}>
                    <Button onClick={() => handleDecrease(productQty)}>
                        <Minus/>
                    </Button>
                    <StyledWrapper className="printOnly">
                        {productQty}
                    </StyledWrapper>
                    <TextField
                        value={productQty}
                        min={1}
                        max={999999}
                        data-test-selector="product_qtyOrdered"
                        onKeyPress={keyPressHandler}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={qtyChangeHandler}
                    />
                    <Button onClick={() => handleIncrease(productQty)} className="plus">
                        <Plus/>
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper className="inventoryWrapper">
                {isQtychanged && !hideInventoryMsgOnQtyChange && 
                    <DSGProductInventoryMessageCustom
                        productId={productId}
                        trackInventory={true}
                        availability={availability}
                        unitOfMeasure={unitofmeasure}
                        isProductDetailsPage={isProductDetailsPage}
                        failedToLoadInventory={false}
                        isPDP={isProductDetailsPage}
                        inventory={inventory}
                        isDiscontinued={false}
                        qtyOrdered={coveoProductInfo.qtyOrdered}
                        isQtychanged={isQtychanged}
                        isPLP={isPLP}
                    />
                }
            </StyledWrapper>
        </>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(CoveoProductQuantityOrdered));